import { findFirstValueDefined } from '@dirootie-toolbox/objects';
import { ScreenTemplate } from '@components-fabric/types';
import { difference } from 'ramda';
import { removeConsecutive } from '@dirootie-toolbox/strings';

const getSectionObjPath = (obj: ScreenTemplate) => {
  const value = findFirstValueDefined<string>(
    ['section.sectionPath', 'section.path', 'section.id'],
    obj,
    'NOT_SET'
  );
  const result = removeConsecutive(['/'], value).replace('_', '-');
  return result as string;
};

const getRouteObjPath = (obj: ScreenTemplate) =>
  findFirstValueDefined<string>(
    ['route.path', 'route.to', 'path', 'id'],
    obj,
    'NOT-SET'
  );

export const getRoutePath = (obj: ScreenTemplate) => {
  const path = [getSectionObjPath(obj), getRouteObjPath(obj)];
  const valid = difference(path, ['.', '/', 'NOT-SET', '']).join('/');
  const result = removeConsecutive(['/'], valid).replace('_', '-');
  return result;
};
